import {
  Component,
  EventEmitter,
  Input,
  input,
  output,
  Output,
} from '@angular/core';

import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { AwButtonIconOnlyDirective } from '@assetworks-llc/aw-component-lib';
import {
  AwDatePickerComponent,
  AwFormFieldLabelComponent,
  AwFormFieldComponent,
  AwFormMessageComponent,
} from '@assetworks-llc/aw-component-lib';

@Component({
  selector: 'app-aw-date-form',
  imports: [
    AwFormFieldComponent,
    AwFormFieldLabelComponent,
    AwFormMessageComponent,
    ReactiveFormsModule,
    AwButtonIconOnlyDirective,
    MatIconModule,
    FormsModule,
    AwDatePickerComponent,
    MatTabsModule,
  ],
  templateUrl: './aw-date-form.component.html',
  styleUrl: './aw-date-form.component.scss',
  standalone: true,
})
export class AwDateFormComponent {
  title = input<string>('');
  subtitle = input<string>('');
  required = input<boolean>(false);

  dateSelected = output<Date | null>();

  placeholder = input<string>('Select Date');
  multiDatePicker = input<boolean>(false);

  datePickerForm = new FormGroup({
    date: new FormControl<Date | null>(null, [Validators.required]),
  });

  ngOnInit() {
    this.datePickerForm.controls['date'].valueChanges.subscribe((newDate) => {
      this.dateSelected.emit(newDate);
    });
  }
}
